const getEventValue = (event: types.topUp.FormEvent) => (event.target as HTMLFormElement).value;

export default getEventValue;
